/** @format */

import {Theme} from '@mui/material/styles';

import {HotspotVariant} from '../types';

const getButtonColor = (variant: HotspotVariant, theme: Theme): string | undefined => {
  switch (variant) {
    case 'blue':
      return theme.palette.semantic_dark?.primary.main;
    case 'orange':
      return theme.palette.semantic_dark?.alert.main;
    default:
      return theme.palette.semantic_dark?.surface.surface2;
  }
};

export {getButtonColor};
